import { gql } from '@apollo/client';

export const CUSTOMER_LOGIN1 = gql`
mutation customerLogin1($loginHandle : String!,$loginmode:String!) {
  customerLogin1(loginHandle: $loginHandle, loginmode:$loginmode) {
    status
    data
    error
  }
}
`;

export const CUSTOMER_LOGIN2 = gql`
mutation customerLogin2($loginHandle : String!, $loginmode : String!, $code : String!, $fingerprint : String!) {
  customerLogin2(loginHandle: $loginHandle, code : $code, loginmode: $loginmode, fingerprint : $fingerprint) {
    status
    error
    token
    dt
}
}
`;

export const UPDATE_USER_PROFILE = gql`
mutation updateProfile($data : CustomerInput!, $code: String!) {
  updateProfile(data: $data, code: $code) {
    status
    error
    token
    dt
  }
}
`;

export const UPDATE_USER_EMAIL_PHONE = gql`
mutation updateEmailPhone($type :String!, $code: String!, $theValue: String!) {
  updateEmailPhone(type: $type, code: $code, theValue: $theValue) {
    status
    error
    token
    dt
  }
}
`;

export const PUBLIC_SEND_SMS = gql`
mutation publicSendSMS($type : String!, $phone : String!) {
  publicSendSMS(type: $type, phone : $phone) {
    data
    status
    error
  }
}
`;

export const PUBLIC_VERIFY_SMS = gql`
mutation publicVerifySMS($type : String!, $phone : String!, $code: String!) {
  publicVerifySMS(type: $type, phone : $phone, code : $code) {
    data
    status
    error
  }
}
`;

export const FINALIZE_REGISTER = gql`
mutation registerCustomer( $data: CustomerInput!, $fingerprint: String!) {
  registerCustomer(data: $data, fingerprint: $fingerprint){
    status
    error
    token
    dt
  }
}
`;

export const PRIVATE_SEND_EMAIL = gql`
mutation privateSendEmail {
  privateSendEmail {
    data
    status
    error
  }
}
`;

export const PUBLIC_SEND_EMAIL = gql`
mutation publicSendEmail($email : String!) {
  publicSendEmail(email : $email) {
    data
    status
    error
  }
}
`;

export const PUBLIC_VERIFY_EMAIL = gql`
mutation publicVerifyEmail($email : String!, $code: String!) {
  publicVerifyEmail(email : $email, code : $code) {
    data
    status
    error
  }
}
`;